var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-bottom-sheet',{ref:"cashupSheet",attrs:{"background-clickable":false,"background-scrollable":false,"click-to-close":true,"is-full-screen":true,"maxHeight":'100vh',"maxWidth":'100%',"overlay":true,"rounded":true,"swipe-able":true}},[_c('CashupSummary',{attrs:{"cashup":_vm.cashup}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }